import React, { useState, useEffect } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFacebookF, faTwitter, faYoutube, faInstagram } from '@fortawesome/free-brands-svg-icons';
import { faChevronUp } from '@fortawesome/free-solid-svg-icons'; // सही इम्पोर्ट

const Footer: React.FC = () => {
  const [isVisible, setIsVisible] = useState(false);

  // Function to handle scroll and show/hide the button
  const toggleVisibility = () => {
    if (window.scrollY > 300) { // Show button after scrolling 300px
      setIsVisible(true);
    } else {
      setIsVisible(false);
    }
  };

  // Function to scroll to the top
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth', // Smooth scrolling effect
    });
  };

  // Add scroll event listener when component mounts
  useEffect(() => {
    window.addEventListener('scroll', toggleVisibility);
    return () => {
      window.removeEventListener('scroll', toggleVisibility);
    };
  }, []);

  return (
    <>
      <footer className="footer-section bg-dark text-white py-5">
        <Container>
          <Row className="g-4">
            <Col md={4}>
              <h5 className="footer-title">About Us</h5>
              <ul className="list-unstyled">
                <li><a href="/about/" className="footer-link">About Srisailam</a></li>
                <li><a href="/core-team/" className="footer-link">Core Team</a></li>
                <li><a href="/mentors/" className="footer-link">Mentors</a></li>
                <li><a href="/privacy-policy/" className="footer-link">Privacy Policy</a></li>
              </ul>
            </Col>
            <Col md={4}>
              <h5 className="footer-title">Our Program</h5>
              <ul className="list-unstyled">
                <li><a href="/education/" className="footer-link">Educations</a></li>
                <li><a href="/women-empowerment/" className="footer-link">Women Empowerments</a></li>
                <li><a href="/environment/" className="footer-link">Environment</a></li>
                <li><a href="/health/" className="footer-link">Health</a></li>
                <li><a href="/livelihood/" className="footer-link">Livelihood</a></li>
              </ul>
            </Col>
            <Col md={4}>
              <h5 className="footer-title">Contact Us</h5>
              {/* <p className="footer-text mb-2">Address: C/O Madhu Mishra, No: 440/E, Tulsi Nagar, Phase 1, Near Pragati Puram colony, Raebareli, UP 229316</p> */}
              <p className="footer-text mb-2"></p>
              <p className="footer-text mb-2">Phone: +91 98385 80001 / +91 94500 08921</p>
              <p className="footer-text mb-3">Email: info@srisailamfoundation.org</p>
              <div className="d-flex gap-3">
                <a href="https://www.facebook.com/srisailamfoundation.org" target="_blank" rel="noopener noreferrer" className="social-link">
                  <FontAwesomeIcon icon={faFacebookF} size="lg" />
                </a>
                <a href="https://x.com/srisailamfndn" target="_blank" rel="noopener noreferrer" className="social-link">
                  <FontAwesomeIcon icon={faTwitter} size="lg" />
                </a>
                <a href="https://youtube.com" target="_blank" rel="noopener noreferrer" className="social-link">
                  <FontAwesomeIcon icon={faYoutube} size="lg" />
                </a>
                <a href="https://www.instagram.com/srisailamfoundation" target="_blank" rel="noopener noreferrer" className="social-link">
                  <FontAwesomeIcon icon={faInstagram} size="lg" />
                </a>
              </div>
            </Col>
          </Row>
        </Container>
      </footer>

      {/* Jump to Top Button */}
      <button
        onClick={scrollToTop}
        className={`jump-to-top ${isVisible ? 'visible' : ''}`}
        title="Go to top"
      >
        <FontAwesomeIcon icon={faChevronUp} size="lg" />
      </button>
    </>
  );
};

export default Footer;